import { addingTimerAutomationFlag } from '../../redux/slices/automation';
import { Close } from '@mui/icons-material';
import CustomDropdown from '../../components/reusable/dropdown';
import CustomInput from '../../components/reusable/input';
import LabelWrapper from '../../components/wrapper/label';
import { timerAutomationSchema } from '../../schema/automation_schema';
import { updateBuildAutomationThunk } from '../../redux/thunks/automation';
import { addNode, editSelectedNode, settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

interface TimerObject {
    type: 'phone' | 'condition' | 'email' | 'timer',
    duration: number;
    duration_type: 'minutes' | 'hours' | 'days' | 'months';
}

const SetTimerComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedNode } = useSelector((state: RootState) => state.workflow);
    const { loaders } = useSelector((state: RootState) => state.automation);
    const initialValues: TimerObject = JSON.parse(JSON.stringify({
        type: 'timer',
        duration: (selectedNode?.data?.duration as number) || 0,
        duration_type: (selectedNode?.data?.duration_type as 'minutes' | 'hours' | 'days' | 'months') || 'minutes'
    }));

    const handleBackNavigation = () => {
        dispatch(settingSelectedNode(null));
        dispatch(settingSelectedEdge(null));
        dispatch(addingTimerAutomationFlag(false));
    };

    const handleSubmit = async (value: TimerObject) => {
        if (selectedNode) {
            dispatch(editSelectedNode(JSON.parse(JSON.stringify(value))));
        } else {
            dispatch(addNode(JSON.parse(JSON.stringify(value))));
        }
        try {
            await dispatch(updateBuildAutomationThunk()).unwrap();
        } catch (e) {
            // Catch errors
        }
        handleBackNavigation();
    };

    return (<Box width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box></Box>
            <Typography variant="h3" fontWeight="bold" textAlign="center">Time Delay</Typography>
            <IconButton disabled={loaders.isUpdating} onClick={handleBackNavigation}><Close /></IconButton>
        </Box>
        <Box maxWidth="600px" minWidth="600px" mx="auto" my={4}>
            <Formik
                initialValues={initialValues}
                validationSchema={timerAutomationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, handleBlur, errors, touched, setFieldValue }) => (
                    <Form>
                        {/* Input for stage name */}
                        <Box display="flex" gap={2}>
                            <Box width="100%">
                                <CustomInput
                                    type="number"
                                    value={values.duration}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        if ((/^\d+$/u).test(value) && Number(value) <= 1000) {
                                            setFieldValue('duration', parseInt(value, 10));
                                        }
                                    }}
                                    onBlur={handleBlur('duration')}
                                    error={touched.duration && errors.duration}
                                    fullWidth
                                    label="Duration"
                                    placeholder="Type here"
                                    variant="outlined"
                                    disabled={loaders.isUpdating}
                                    inputProps={{ min: 1, step: 1 }}
                                /></Box>
                            {/* Input for days due */}
                            <Box width="100%">
                                <LabelWrapper label="Select Duration Type" />
                                <CustomDropdown
                                    options={[
                                        { label: 'Minutes', value: 'minutes' },
                                        { label: 'Hours', value: 'hours' },
                                        { label: 'Days', value: 'days' },
                                        { label: 'Months', value: 'months' }
                                    ]}
                                    value={values.duration_type}
                                    onChange={(e) => {
                                        setFieldValue('duration_type', e.target.value);
                                    }}
                                    disabled={loaders.isUpdating}
                                    sx={{ marginBottom: '0' }}
                                />
                            </Box>
                        </Box>
                        {/* Action buttons for cancel and submit */}
                        <Box display="flex" flexDirection="row-reverse" gap={2} mt={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loaders.isUpdating}
                            >
                                {selectedNode && loaders.isUpdating ? 'Updating' : selectedNode ? 'Update' : loaders.isUpdating ? 'Creating' : 'Create'} action
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleBackNavigation}
                                disabled={loaders.isUpdating}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>
    </Box>);
};

export default SetTimerComponent;